import _ from "lodash";
export const allPopulated = (items) => {
    return _.every(items, (i) => !!i);
};
